import {log} from '../log';
import pairingService from '../pairingService';
import deviceIdlePingService from './deviceIdlePingService';

// This scheduler is used to ping device while no frames are being written to it
// it prevents the device from sleeping

const PING_TIMEOUT_MS = 15_000;

let isStarted = false;
let isPaused = false;
let schedulerTimeout;

const startScheduler = () => {
    if (isStarted) return;
    isStarted = true;

    log.debug('deviceIdlePingScheduler: startScheduler');
    resetScheduler(true);
};

const killScheduler = () => {
    if (!isStarted || !schedulerTimeout) return;

    log.debug('deviceIdlePingScheduler: killScheduler');
    clearInterval(schedulerTimeout);
    isStarted = false;
};

const resetScheduler = (startImmediately) => {
    if (!isStarted || isPaused) return;

    clearInterval(schedulerTimeout);

    schedulerTimeout = setTimeout(
        () => {
            const isDeviceConnected = pairingService.isDeviceConnected();

            if (!isDeviceConnected) {
                killScheduler();
                return;
            }

            deviceIdlePingService.writePingFrame();
        },
        startImmediately ? 0 : PING_TIMEOUT_MS
    );
};

const pauseScheduler = () => {
    isPaused = true;
};

const unpauseScheduler = () => {
    isPaused = false;
    resetScheduler();
};

export default {
    startScheduler,
    resetScheduler,
    killScheduler,
    pauseScheduler,
    unpauseScheduler,
};
